<template>

  <modalo
    :title="careerpage.name"
    type="mini"
    @hideModal="hideModal()"
    :modaloWatch="() => careerpage">

    <form id="careerpage-form" v-on:submit.prevent="saveCareerpage(careerpage)">
      <div class="form-group">
        <label>{{ $t('Title') }}</label>
        <input v-autofocus type="text" class="form-control" v-model="careerpage.title">
        <ValidateMessage :error="validateErrors.title" />
      </div>
      <div class="form-group">
        <label>Slug</label>
        <input type="text" class="form-control" v-model="careerpage.slug">
        <ValidateMessage :error="validateErrors.slug" />
      </div>
      <div class="form-group">
        <label>{{ $t('Main') }}</label>
        <div>
          <input type="checkbox" v-model="careerpage.default"> {{ $t('Yes') }}
        </div>
        <ValidateMessage :error="validateErrors.default" />
      </div>
    </form>

    <template slot="footer">
      <div :class="{'box-loading': loading}">
        <button
          type="submit"
          form="careerpage-form"
          class="btn btn-primary">{{ $t('Save') }}</button>
        <button
          type="button"
          class="btn btn-light"
          @click="hideModal()">{{ $t('Cancel') }}</button>
        <button
          v-if="careerpage._id"
          type="button"
          class="btn btn-danger"
          @click="deleteCareerpage(careerpage._id)">{{ $t('Delete') }}</button>
      </div>
    </template>

  </modalo>

</template>

<script>
export default {
  name: 'CareerpageForm',
  components: {
  },
  props: [
    'initCareerpage'
  ],
  data () {
    return {
      loading: false,
      careerpage: this.defaultValues(this.initCareerpage),
      validateErrors: {}
    }
  },
  created () {
  },
  methods: {
    /*
    defaultValues
    */
    defaultValues (values) {
      return values._id
      ? this.$clone(values)
      : Object.assign({
      }, values)
    },
    /*
    hideModal
    */
    hideModal () {
      this.$emit('hideModal')
    },
    /*
    saveCareerpage
    */
    saveCareerpage (data) {
      if (data._id) this.updateCareerpage(data)
      else this.createCareerpage(data)
    },
    /*
    createCareerpage
    */
    createCareerpage (data) {
      this.loading = true

      this.$store
      .dispatch('createCareerpage', data)
      .then((result) => {
        this.loading = false
        this.$emit('saved')
      })
      .catch((err) => {
        this.loading = false
        if (err.response.data.name === 'ValidationError') {
          this.validateErrors = err.response.data.errors
        }
      })
    },
    /*
    updateCareerpage
    */
    updateCareerpage (data) {
      this.loading = true

      this.$store
      .dispatch('updateCareerpage', data)
      .then((result) => {
        this.loading = false
        this.$emit('saved')
      })
      .catch((err) => {
        this.loading = false
        if (err.response.data.name === 'ValidationError') {
          this.validateErrors = err.response.data.errors
        }
      })
    },
    /*
    delete
    */
    deleteCareerpage (id) {
      const deleteAction = () => {
        this.loading = true

        this.$store
        .dispatch('deleteCareerpage', id)
        .then((result) => {
          this.loading = false
          this.$emit('saved')
        })
      }

      this.$store
      .dispatch('setAlertModal', {
        action: deleteAction
      })
    }

  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Careerpage/CareerpageForm.vue